import { render } from "./CoinVol.vue?vue&type=template&id=55dc1624"
import script from "./CoinVol.vue?vue&type=script&lang=js"
export * from "./CoinVol.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__